import { render, staticRenderFns } from "./SearchResultUserItem.vue?vue&type=template&id=efc04e1c&scoped=true"
import script from "./SearchResultUserItem.vue?vue&type=script&lang=js"
export * from "./SearchResultUserItem.vue?vue&type=script&lang=js"
import style0 from "./SearchResultUserItem.vue?vue&type=style&index=0&id=efc04e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc04e1c",
  null
  
)

export default component.exports